import { render } from "./OnlineMinigames.vue?vue&type=template&id=498bd633"
import script from "./OnlineMinigames.vue?vue&type=script&lang=js"
export * from "./OnlineMinigames.vue?vue&type=script&lang=js"

import "./OnlineMinigames.vue?vue&type=style&index=0&id=498bd633&lang=css"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__